<template>
  <SidebarCard productName="Business Studio+" :header="$t('tbs_home_plus_header')" :logo="BusinessPlusLogo">
    <ul class="tw:text-sm tw:gap-y-2 tw:flex tw:flex-col tw:w-full">
      <li
        v-for="action in actions"
        :key="action.id"
        class="tw:hover:cursor-pointer tw:flex tw:justify-between tw:w-full tw:hover:underline"
      >
        <router-link
          class="tw:flex tw:justify-between tw:w-full"
          :to="action.link"
          @click="trackEvent(action.eventName)"
        >
          {{ $t(action.label) }}
          <ChevronRight class="tw:size-6" />
        </router-link>
      </li>
    </ul>
  </SidebarCard>
</template>
<script setup>
import SidebarCard from '@/components/homePage/sidebar/SidebarCard.vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const BusinessPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

const actions = [
  {
    id: 0,
    label: 'tbs_home_plus_feature_1',
    link: { name: 'hotel-offers' },
    eventName: appAnalytics.events.HOMEPAGE_SIDEBAR_PLUS_ACTIVE_HO,
  },
  {
    id: 1,
    label: 'tbs_home_plus_feature_2',
    link: { name: 'rate-insights' },
    eventName: appAnalytics.events.HOMEPAGE_SIDEBAR_PLUS_ACTIVE_RI,
  },
  {
    id: 2,
    label: 'tbs_home_plus_feature_3',
    link: { name: 'visitors-profile-stay-duration' },
    eventName: appAnalytics.events.HOMEPAGE_SIDEBAR_PLUS_ACTIVE_VP,
  },
  {
    id: 3,
    label: 'tbs_home_plus_feature_4',
    eventName: appAnalytics.events.HOMEPAGE_SIDEBAR_PLUS_ACTIVE_PD,
    link: {
      name: 'property-details-basic-information',
      query: { open_update: true },
    },
  },
]

const trackEvent = eventName => {
  appAnalytics.track(eventName, { accommodationId: selectedAccommodationId.value })
}
</script>
